import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Spacer } from '@ontruck/orc';
import OrderDetailTotalPrice from './components/OrderDetailTotalPrice';
import LoadSpinner from 'components/LoadSpinner';
import LiteralCurrency from 'components/LiteralCurrency';
import PriceConceptsBreakdown from 'components/PriceConceptsBreakdown';
import { useTranslation } from 'react-i18next';
import { isEmpty } from 'utils/types';
import { getExtras, getPriceConcepts } from 'utils/order';
import { constants as extrasConstants } from 'utils/extras';

const OrderDetailPrice = ({ className, order }) => {
  const { t } = useTranslation('Quote');
  const {
    net_price: basePrice,
    net_full_price: totalPrice,
    gross_full_price: fullPrice,
  } = order || {};

  const isDataReady = useMemo(() => !isEmpty(order), [order]);
  const priceConcepts = useMemo(() => {
    const extras = getExtras({
      priceInfo: order,
      filterExtras: false,
      t,
      removeZeros: true,
    });
    return getPriceConcepts({ basePrice, extras, t });
  }, [t, order, basePrice]);

  const orderExtras = order.extras || [];
  const hasHandlingExtras = orderExtras.some((r) =>
    [
      extrasConstants.HANDLING_LOADING,
      extrasConstants.HANDLING_UNLOADING,
    ].includes(r)
  );

  return (
    <div className={className}>
      <h1>{t('Summary:details')}</h1>
      {isDataReady && (
        <PriceConceptsBreakdown
          concepts={priceConcepts}
          collapsable={false}
          showTooltips
          hasHandlingExtrasInDetail={hasHandlingExtras}
        />
      )}
      <div className="total-container">
        {isDataReady ? (
          <>
            <OrderDetailTotalPrice totalPrice={Number(totalPrice)} />
            {!!fullPrice && (
              <div className="vat-value">
                <LiteralCurrency value={fullPrice} /> {t('including_vat')}
              </div>
            )}
          </>
        ) : (
          <Spacer mBottom="M">
            <LoadSpinner
              loadText={t('load_text')}
              loadTitle={t('load_title')}
              skin="standar"
            />
          </Spacer>
        )}
      </div>
    </div>
  );
};

OrderDetailPrice.propTypes = {
  order: PropTypes.object.isRequired,
};

export default OrderDetailPrice;
